import React, { useEffect, useState } from "react";
import { Link, Navigate, useNavigate, useLocation, useSearchParams } from "react-router-dom";
import {
  selectRep,
  getRepFolderInfo,
  resetRep,
} from "../../redux-store/rep/repSlice";
import { useAppSelector, useAppDispatch } from "../../store";
import MainMenu from "../header/MainMenu";
import GoogleTranslate from "./GoogleTranslate";
import { toInteger } from "lodash";
type Product = {
  prodname?: string;
};

const Header = (props: Product) => {
  const dispatch = useAppDispatch();
  const { data: rep, status } = useAppSelector(selectRep);

  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [url, setUrl] = useState("");
  const [searchParams] = useSearchParams();

  const [hasCalledGetRepFolder, setHasCalledGetRepFolder] = useState(false);

  const splitLocation = pathname.split("/");

  const foldername =
    splitLocation.length === 3
      ? splitLocation[2]
      : splitLocation.length === 2 && props.prodname === "404"
        ? splitLocation[1]
        : "";


  // Handle URL setup and navigation
  useEffect(() => {
    if (rep) {
      const newUrl = rep.repFolder + ((searchParams.toString() != "") ? "?" + searchParams.toString() : "");
      setUrl(newUrl);


      if (foldername === "404") {
        navigate("/404");
      } else if (splitLocation.length === 2 && props.prodname === "404" && rep.repFolder) {
        navigate("/home/" + newUrl);
      } else if (status === "failed" && foldername !== "" && foldername !== "404") {
        navigate("/404");
      }
    }
  }, [rep, status, pathname, searchParams, props.prodname, navigate, foldername, splitLocation.length]);

  // Call getRepFolderInfo only once when foldername changes
  useEffect(() => {
    if (
      rep &&
      foldername &&
      foldername !== "404" &&
      foldername.toLowerCase() !== rep.repFolder.toLowerCase() &&
      (pathname.match(/\//g) || []).length <= 2 &&
      !hasCalledGetRepFolder
    ) {
      console.log("Calling getRepFolderInfo for: " + foldername);

      const cid = searchParams.get("cid");
      dispatch(getRepFolderInfo({ folderName: foldername, cid: cid || "" }));

      setHasCalledGetRepFolder(true);
    } else if ((pathname.match(/\//g) || []).length > 2) {
      dispatch(resetRep());
      setHasCalledGetRepFolder(false);
    }
  }, [foldername, rep, pathname, dispatch]);

  // Ensure the phone number is a string
  const MainPhoneNumber = toInteger(rep!.repPhone);
  function formatPhoneNumber(phoneNumber: number) {
    // Ensure the phone number is a string
    const cleaned = ('' + phoneNumber).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return null;
  }
  const formattedPhoneNumber = formatPhoneNumber(MainPhoneNumber);

  return (
    <>
      {status == "failed" && foldername != "" && foldername != "404" ? (
        <>
          <Navigate to="/404" />
        </>
      ) : (
        <>
          <header className="theme-main-menu sticky-menu bg-white fixed shadow">
            <div className="notice-banner text-center py-2 px-3 px-sm-3 px-md-5 px-lg-0 px-xl-5 bg-globalblue">
              {/* It's the last day to save. The skills for now —{" "}
        <a href="/" className="fw-500">
          now on sale.
        </a> */}
              <div className="row">
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex flex-wrap justify-content-center justify-content-sm-center justify-content-md-start justify-content-lg-start justify-content-xl-start">
                  <p
                    className="pe-2 ps-2 mb-0 d-flex align-items-center border-end border-white border-1 small text-white fs-13"
                    data-toggle="tooltip"
                    data-placement="top"
                    title={rep!.repName}
                  >
                    <img
                      src="/images/icon/icon_person.svg"
                      alt=""
                      className="me-2 h-auto w-auto"
                    />
                    {rep!.repName}
                    {/* Corporate Office */}
                  </p>
                  <p className="pe-2 ps-2 mb-0 d-flex align-items-center small text-white fs-13">
                    <img
                      src="/images/icon/icon_email.svg"
                      alt=""
                      className="me-2 h-auto w-auto"
                    />
                    <Link
                      to={"mailto:" + rep!.repEmail}
                      className="email tran3s"
                    >
                      {rep!.repEmail}
                    </Link>
                  </p>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <div className="right-widget ms-auto d-flex flex-wrap justify-content-center justify-content-sm-center justify-content-md-end justify-content-lg-end justify-content-xl-end align-items-center order-lg-3 me-3">
                    <p className="pe-3 ps-2 pe-xl-3 mb-0 d-flex align-items-center border-end border-white border-1 small text-white fs-13">
                      <img
                        src="/images/icon/icon_talk.svg"
                        alt=""
                        className="me-2 h-auto w-auto"
                      />
                      <Link
                        to={"tel:+" + rep!.repPhone}
                        className="email tran3s"
                      >
                        {formattedPhoneNumber}
                      </Link>
                    </p>
                    <div className="small lang-dropdown position-relative ms-3 me-3 ms-xl-3 me-xl-3 fs-13">
                      <button
                        className="dropdown-toggle text-white fs-13"
                        type="button"
                        id="langDropdown"
                        data-bs-toggle="dropdown"
                        data-bs-auto-close="true"
                        aria-expanded="false"
                      >
                        En
                      </button>
                      <ul
                        className="dropdown-menu fs-13 p-2"
                        aria-labelledby="langDropdown"
                      >
                        <li>
                          <GoogleTranslate />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="inner-content position-relative mt-10">
              <div className="d-flex align-items-center justify-content-between">
                <div className="logo order-lg-0">
                  <Link to={"/home/" + url} className="d-block pe-3">
                    <img
                      src="/images/logo/UWE_PP_Logo.webp"
                      className="h-auto w-75"
                      alt="uwepp logo"
                    />
                  </Link>
                </div>
                <div className="right-widget ms-auto d-flex align-items-center order-lg-3 me-3">
                  <Link
                    className="align-items-center btn-one fs-16 fw-500 text-white tran3s d-none d-lg-flex mx-2"
                    type="button"
                    id="langDropdown" to="https://portal.ucesprotectionplan.com/"
                    target="_blank"                >
                    <img
                      src="/images/icon/icon_62.svg"
                      alt="icon"
                      className="me-2 h-auto w-auto"
                    />
                    Login
                  </Link>
                  {/* <button
                    className="dropdown-toggle align-items-center btn-one fs-16 fw-500 text-white tran3s d-none d-lg-flex mx-2"
                    type="button"
                    id="langDropdown"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="true"
                    aria-expanded="false"
                  >
                    <img
                      src="/images/icon/icon_62.svg"
                      alt="icon"
                      className="me-2 h-auto w-auto"
                    />
                    Login
                  </button>
                  <ul
                    className="dropdown-menu fs-6"
                    aria-labelledby="langDropdown"
                  >
                    <li>
                      <Link to="https://portal.ucesprotectionplan.com/" target={"_blank"} className="dropdown-item">
                      New Portal
                      </Link>
                    </li>
                    <li>
                      <Link to="https://ucespp.memberaccount.net" target={"_blank"} className="dropdown-item">
                      Old Portal
                      </Link>
                    </li>
                  </ul> */}
                </div>

                {/* /.right-widget */}
                <MainMenu />
              </div>
            </div>
            {/* /.inner-content */}
          </header>
        </>
      )}
    </>
  );
};

export default Header;
